/* eslint-disable react/destructuring-assignment */
import React from "react";

const UnderlineIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.16669 12.832H12.8334"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8334 3.16797V7.33464C10.8334 8.89944 9.56483 10.168 8.00002 10.168C6.43521 10.168 5.16669 8.89944 5.16669 7.33464V3.16797"
        stroke="#64748B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UnderlineIcon;

export const StrikeThroughIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.16666 8.16634H12.8333M12.1667 5.49967V5.33301C12.1667 4.22844 11.2712 3.33301 10.1667 3.33301H5.83333C4.72876 3.33301 3.83333 4.22844 3.83333 5.33301V6.16634C3.83333 7.27091 4.72876 8.16634 5.83333 8.16634H10M3.83333 10.4997V10.833C3.83333 11.9376 4.72876 12.833 5.83333 12.833H10.1667C11.2712 12.833 12.1667 11.9376 12.1667 10.833V9.83301"
        stroke={props.color || "#64748B"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
